import { LoanPropertyHadPermitAtClosingType } from './LoanPropertyHadPermitAtClosingType';

export const LoanPropertyHadPermitAtClosingTypeOptions = [
    {
        id: LoanPropertyHadPermitAtClosingType.Yes,
        name: 'Yes',
    },
    {
        id: LoanPropertyHadPermitAtClosingType.No,
        name: 'No',
    },
    {
        id: LoanPropertyHadPermitAtClosingType.NAPermitNotRequired,
        name: 'N/A - permit not required',
    },
];
